import { useAuth } from '../context/AuthContext';
import { useEffect, useState, useCallback } from 'react';

// Hook for fetching pending users
export const usePendingUsers = () => {
  const { acquireToken, isAuthenticated, login } = useAuth();
  const [pendingUsers, setPendingUsers] = useState([]);
  const [error, setError] = useState(null);

  // Define fetchPendingUsers as a useCallback to memoize the function
  const fetchPendingUsers = useCallback(async () => {
    if (!isAuthenticated) {
      console.log('fetchPendingUsers Logging in')
      login();
      return; // Avoid fetching if the user is not authenticated
    }
    try {
      const token = await acquireToken(['user.read']);
      const response = await fetch('/api/pending-users', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 && data.message === 'Token has expired!') {
          console.log('bad token, loggin in')
          login();
        }
        throw new Error(data?.message || 'An unexpected error occurred.');
      }

      setPendingUsers(data);
    } catch (error) {
      console.error('Error fetching pending users:', error);
      setError(error.message);
    }
  }, [acquireToken, isAuthenticated, login]);

  useEffect(() => {
    fetchPendingUsers();
  }, [fetchPendingUsers]);

  return { pendingUsers, error, refreshPendingUsers: fetchPendingUsers }; // Return the fetch function as refreshPendingUsers
};

export const useRemoveUser = (refreshPendingUsers) => {
  const { acquireToken, isAuthenticated, login } = useAuth();
  const [error, setError] = useState(null);

  const removeUser = async (message_id) => {
    if (!isAuthenticated) {
          console.log('removeUser loggin in')
      login();
      return; // Early return if not authenticated
    }

    try {
      const token = await acquireToken(['user.read']);
      const response = await fetch('/api/pending-users', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message_id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 401 && errorData.message === 'Token has expired!') {
          console.log('removeUser bad token loggin in')
          login();
        }
        throw new Error(errorData?.message || 'Failed to remove user.');
      }

      // Wait for 2 seconds before refreshing the pending users list
      setTimeout(() => {
        refreshPendingUsers();
      }, 2000);

    } catch (error) {
      console.error('Removal failed:', error.message);
      setError(error.message);
    }
  };

  return { removeUser, error };
};



export const useAcceptUser = (refreshPendingUsers) => {
  const { acquireToken, isAuthenticated, login } = useAuth();
  const [error, setError] = useState(null);

  const acceptUser = async (message_id, email, first_name, last_name) => {
    if (!isAuthenticated) {
          console.log('acceptUser loggin in')
      login();
      return; // Early return if not authenticated
    }

    try {
      const token = await acquireToken(['user.read']);
      const response = await fetch('/api/pending-users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message_id, email, first_name, last_name }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 401 && errorData.message === 'Token has expired!') {
          console.log('acceptUser bad token loggin in')
          login();
        }
        throw new Error(errorData?.message || 'Failed to accept user.');
      }
      
      // Wait for 2 seconds before refreshing the pending users list
      setTimeout(() => {
        refreshPendingUsers();
      }, 2000);

    } catch (error) {
      console.error('accept failed:', error.message);
      setError(error.message);
    }
  };

  return { acceptUser, error };
};
